class TrTabs extends HTMLElement {
	selectors = {
		button: '[data-button]',
		content: '[data-content]'
	};

	nameAttributes = {
		buttonIndex: 'data-button-index',
		contentIndex: 'data-content-index',
		ariaSelected: 'aria-selected'
	};

	stateClasses = {
		isActive: 'is-active',
		isVisible: 'is-visible'
	};

	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.buttonElements = Array.from(
			this.querySelectorAll(this.selectors.button)
		);
		this.contentElements = Array.from(
			this.querySelectorAll(this.selectors.content)
		);

		if (!this.buttonElements.length || !this.contentElements.length) return;

		this.buttonElements.forEach(buttonElement => {
			buttonElement.addEventListener('click', this.onButtonClick);
		});
	}

	onButtonClick = event => {
		const button = event.currentTarget;

		const buttonIndex = button.getAttribute(this.nameAttributes.buttonIndex);

		this.buttonElements.forEach(buttonElement => {
			buttonElement.classList.remove(this.stateClasses.isActive);
			buttonElement.setAttribute(this.nameAttributes.ariaSelected, 'false');
		});

		this.contentElements.forEach(contentElement => {
			contentElement.classList.remove(this.stateClasses.isVisible);
		});

		button.setAttribute(this.nameAttributes.ariaSelected, 'true');

		button.classList.add(this.stateClasses.isActive);

		const content = this.contentElements.find(
			contentElement =>
				contentElement.getAttribute(this.nameAttributes.contentIndex) ===
				buttonIndex
		);

		content.classList.add(this.stateClasses.isVisible);
	};
}

customElements.define('tr-tabs', TrTabs);
